import React, { Component, useState } from 'react'
import Button from './ui/Button.jsx'
import { Redirect } from 'react-router-dom';
import { connect } from "react-redux";
import { useStore } from '../zustand'
import { store } from 'react-notifications-component';
import axios from 'axios'
import Masonry from 'react-masonry-component';

class Radio extends Component {
    constructor (props) {
        super(props)
        this.state = {
          playing: false,
          url:"",
          name:"",
          shortname:"",
          isFetching: false,
          radios: ['http://sc2.radiocaroline.net:8040/;'],
          urlsstorage: [['https://nebcoradio.com:1010/KBEN','The Adventure The Big Horns Genuine Country ', 'KBN', '1'],['https://musicbird.leanstream.co/CFCYFM-MP3-2','CFCY-FM Charlottetown, PE, Canada, The Islands Country', 'CFY', '2'],['https://ice07.fluidstream.net/KKItalia.mp3','Radio Kiss Italia Napoli, Radio ufficiale SSC Napoli', 'KKS', '3'],['https://icecast2.play.cz/country64.mp3','Klidné rádio do neklidné doby', 'PRA', '4']]
        }
        this.removeRadio = this.removeRadio.bind(this) 
        this.handlePlay = this.handlePlay.bind(this)
        this.handleChange = this.handleChange.bind(this) 
        this.handleSubmit = this.handleSubmit.bind(this) 
    }
    handlePlay () {
        this.props.updatePlayer(this.state.radios)
    }
    handleChange(event){ 
      this.setState({ 
        // Computed property names 
        // keys of the objects are computed dynamically 
        [event.target.name] : event.target.value
      })
    } 
    removeRadio(id){
      /*
      console.log("REMOVE RADIO "+id)
      this.state.urlsstorage.forEach(item => {
        if (item[3] == id){
          console.log("REMOVE RADIO ITEM "+id)
          let arrayconvert = this.state.urlsstorage.splice((id-1), 1, '');
          console.log("ARRAYCONVERT "+arrayconvert)
          this.setState({
            urlsstorage: arrayconvert
          })
          console.log("REMOVE state ITEM "+this.state.urlsstorage)
        }
      });*/
    }
    handleSubmit(event){ 
      event.preventDefault()
      const { url, name, shortname } = this.state 
      //console.log("URL SUBSTRING "+url.substring(0, 3))
      //console.log("URL SUBSTRING "+url.substring(0, 3))
      //verification
      if (typeof url === 'string' && (url.substring(0, 4) == "http" )){
        if ((shortname.length < 4) && typeof shortname === 'string') {
          if ((name.length < 20 ) && typeof name === 'string') {
            if ( shortname != ""){
              let arraylength = this.state.urlsstorage.length
              console.log("ARRAYLENGTH "+arraylength)
              let lastid = this.state.urlsstorage[arraylength-1][3]
              let id = Number(lastid)+1
              console.log("LAST ID "+lastid)

              let arrayUrls = this.state.urlsstorage
              arrayUrls.push([url, name, shortname, id])
              this.setState({
                urlsstorage: arrayUrls
              })

              alert(` 
                ____Your Details____\n 
                Email : ${url} 
                Name : ${name} 
                Age : ${shortname} 
                Id: ${id}
              `)  
  
              this.props.parentCallback(this.state.urlsstorage);
              event.preventDefault();
            }
            else
            {
              store.addNotification({
                title: "Remplis tous les champs ;)",
                message: "Doucement le matin, pas trop vite l'après-midi.",
                type: "warning",
                insert: "top",
                container: "top-right",
                animationIn: ["animate__animated", "animate__fadeIn"],
                animationOut: ["animate__animated", "animate__fadeOut"],
                dismiss: {
                  duration: 3000,
                  onScreen: true
                }
              });
            }
          }
          else
          {
            store.addNotification({
              title: "Pas plus de vingt caractères :(",
              message: "Tu aimes défier les règles toi.",
              type: "warning",
              insert: "top",
              container: "top-right",
              animationIn: ["animate__animated", "animate__fadeIn"],
              animationOut: ["animate__animated", "animate__fadeOut"],
              dismiss: {
                duration: 3000,
                onScreen: true
              }
            });
          }
        }
        else
        {
          store.addNotification({
            title: "Pas plus de trois caractères... ...",
            message: "La règle était pourtant simple !",
            type: "warning",
            insert: "top",
            container: "top-right",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
              duration: 3000,
              onScreen: true
            }
          });
        }
      }
      else
      {
        store.addNotification({
          title: "Trouve une vraie URL mec!",
          message: "Vous devez uploader une URL (http/https) valide",
          type: "warning",
          insert: "top",
          container: "top-right",
          animationIn: ["animate__animated", "animate__fadeIn"],
          animationOut: ["animate__animated", "animate__fadeOut"],
          dismiss: {
            duration: 3000,
            onScreen: true
          }
        });
      }
    }
    componentWillUnmount() {
      clearInterval(this.timer);
      this.timer = null;
    }
    render () {
        const { user: currentUser } = this.props;
        console.log("CURRENT USER : "+JSON.stringify(currentUser)) 
        return (
          <div>
            <div>
            <Button onClick={this.handlePlay} className="play-pause">Play/Pause</Button>
            </div>
            <form onSubmit={this.handleSubmit} className="create-radio-form">
                <p className="CTA-text">Hit the button to play, to pause, get next radio by playing again.</p>
                <br/>
                <h4>URL</h4>
                <input type="text" value={this.state.url} name="url" onChange={this.handleChange}/>
                <h4>Name</h4>
                <input type="text" value={this.state.name} name="name" onChange={this.handleChange}/>
                <h4>Shortname ( 3 letters max ):</h4>
                <input type="text" value={this.state.shortname} name="shortname" onChange={this.handleChange}/>
                <br/>
                <br/>
            <button className="create-radio-button radio-button">Create Radio</button> 
            <p className="preloader-description-disclaimer">(no database with this, so you'll lose everything if you refresh...). Uses mp3 links from : http://fmstream.org/ !</p>
            </form>
            <p></p>
              <div>
                <ul className="radio-list">
                <h3>Default radios list :</h3>
                <Masonry>
                  {this.state.urlsstorage.map((item, i) => {     
                      //console.log("Entered !!!!!!!");                 
                      // Return the element. Also pass key     
                      return (
                      <div className="masonry-tile">
                        
                          <li className="radios-list" key={item}>
                           <span className="radio-brick">
                            <h4>{String(item[1])}</h4>
                            <h5>{String(item[2])}</h5>
                           </span>
                          </li>
                         
                        
                      </div>
                      ) 
                  })}
                  </Masonry>
                </ul>
              </div>

          </div>
        )
    }
}

function mapStateToProps(state) {
    const { user } = state.auth;
    return {
      user,
    };
}
  

export default connect(mapStateToProps)(Radio)


/*
 <button className="delete-radio radio-button" onClick={() => { this.removeRadio(item[3]) }}>removeRadio</button>
*/
